/**
 * Configurations used when redirecting the user to the LoginConnector.
 */
export const loginConnector = {
    profile: "gu-unic",
    signIn: {},
    signOut: {},
};
